import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '../../services/i18n.service';
import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ModalSearchComponent } from "../modal-search/modal-search.component";

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  imports: [CommonModule, TranslateModule, RouterModule, ModalSearchComponent, ModalSearchComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.open]': 'open',
    '[class.floating]': 'floating',
  },
  animations: [
    trigger('staggerAnimation', [
      transition('false => true', [
        // When open changes from false to true
        query(
          '.stagger-item',
          [
            style({ opacity: 0, transform: 'translateY(0px)' }),
            stagger(75, [
              animate(
                '0.05s ease-out',
                style({ opacity: 1, transform: 'translateY(0)' }),
              ),
            ]),
          ],
          { optional: true },
        ),
      ]),
      transition('true => false', [
        // Optional: animate when closing
        query(
          '.stagger-item',
          [
            animate(
              '0.2s ease-in',
              style({ opacity: 0, transform: 'translateY(0px)' }),
            ),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class MenuComponent implements OnInit {
  @Input() floating = false;
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();

  @Input() isSearch = false

  altBackground = false;

  protected readonly i18nService = inject(I18nService);
  private readonly router = inject(Router);
  private readonly apiService = inject(ApiService);

  protected readonly products$ = this.apiService.getProductItems$();
  protected readonly systems$ = this.apiService.getSystemItems$();

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.openChange.emit(false);
      });
  }

  @HostListener('click')
  handleHostClick(): void {
    // Close the menu on outside click (only receiving click events when open)
    this.openChange.emit(false);
  }

  switchLanguage(language: 'en' | 'de'): void {
    this.i18nService.setLanguageAndReload(language);
  }
}
